/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-extraneous-dependencies
import { PruneCluster, PruneClusterForLeaflet } from 'exports-loader?PruneCluster,PruneClusterForLeaflet!prunecluster/dist/PruneCluster.js';
import {
  DivIcon,
  LayerGroup, LeafletEvent, Marker,
} from 'leaflet';
import { IParkingZoneData } from '@/interfaces/IParkingZoneData';
import IFeature from '@/interfaces/IFeature';
import { IModalData } from '@/services/layers/IModalData';

export default class ParkingZonePointsLayerService extends LayerService {
  markerIcon = 'strefy-parkowania.svg';

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const template: string = metaData.description;

    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: leafletMarker,
      lastUpdate: '',
      icon: this.markerIcon,
      hideModalBtn: true,
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const { parkingZones } = store.state;
    const pruneCluster = new PruneClusterForLeaflet(this.clusteringConstant);

    // WARN: the code inside this function isn't type safe because the plugin
    // doesn't have popper type definitions.
    pruneCluster.PrepareLeafletMarker = (leafletMarker: Marker, data: any): void => {
      const metaData = data.metaData as IParkingZoneData;
      metaData.navigationLatLng = leafletMarker.getLatLng();
      leafletMarker.setIcon(new DivIcon({
        html: this.generateHtmlPointTemplate(metaData, leafletMarker),
        iconSize: [25, 25],
        iconAnchor: [25 / 2, 25 / 2],
        popupAnchor: [-3, -76],
      }));
      // events have bound itself multiple times
      // during redraw so it's safer to remove them
      leafletMarker.off('click');
      leafletMarker.on('click', (e) => {
        this.onClick(e, metaData, leafletMarker);
      });
    };

    parkingZones.features.map((feature: IFeature): PruneCluster.Marker => {
      const [lat, lng] = this.findPolygonCenter(feature);
      const marker: PruneCluster.Marker =
        this.createPruneClusterMarker({ lat, lng }, feature);
      pruneCluster.RegisterMarker(marker);
      return marker;
    });

    return pruneCluster;
  };

  protected generateHtmlPointTemplate = (metaData: any, leafletMarker: Marker<any>): string => {
    const template: string = `
        <div
          class="map-simple-icon map-simple-icon--parking-meter"
          style='background-image: url("${require('@/assets/img/map-icons/' + this.markerIcon)}")'>
        <div>
      `;
    return template;
  }
}
